/* @jsx jsx */
import { jsx } from "theme-ui";
import { highlight, languages } from "prismjs";
import "prismjs/components/prism-jsx";
import "prismjs/components/prism-shell-session";

const languageMap: Record<string, string> = {
  javascript: "jsx",
  html: "jsx",
  shell: "shell-session",
};

export const Code: React.FC<{
  code: string;
  projectId?: string;
  language: string;
}> = (props) => {
  // Add projectId to code snippets
  const code = props.code.replace(
    /((?:projectId|pid)(?:=|\:)\s*"?)(\.\.\.|…)("?)/g,
    (_, prefix, dots, suffix) => `${prefix}${props.projectId || dots}${suffix}`
  );
  const lowercase = props.language.toLowerCase();
  const language = languageMap[lowercase] || lowercase;
  const prismLanguage = languages[language] || languages.jsx;

  const langClass = `language-${language}`;

  return (
    <pre
      className={`notion-code ${langClass}`}
      sx={{ fontSize: `0.9em!important`, borderRadius: 8 }}
    >
      <code
        className={langClass}
        sx={{
          ...(language === "shell-session"
            ? {
                "&:before": {
                  content: '"$ "',
                },
              }
            : {}),
        }}
        dangerouslySetInnerHTML={{
          __html: highlight(code, prismLanguage, language),
        }}
      />
    </pre>
  );
};
